import { useToggle } from '@bygghemmait/hooks';
import cn from 'classnames';
import { Button } from 'components/Button';
import { IconSvea } from 'components/Shared/Icon';
import Modal from 'components/Shared/Modal';
import { useExperiment } from 'experiments/experiment';
import experiment from 'experiments/partPaymentPdp.experiment';
import { useSelector } from 'react-redux';
import { hasElements, rm, withCurrentPage } from 'utils';
import { CreditWarning } from 'views/CheckoutPage/themes/BGH/payment/creditWarning';
import { getPrice, selectPartPayment } from 'views/ProductPage/selector';
import styles from './partPaymentWidget.scss';

export const PartPaymentWidget = () => {
  const partPayments = useSelector(selectPartPayment);
  const { variant } = useExperiment({ experiment });
  const [showModal, toggleModal] = useToggle(false);
  const presentationPrice = useSelector(withCurrentPage(getPrice)).presentationPrice;

  const hasPartPayments = hasElements(partPayments);
  const isPartPaymentExperimentActive = variant === 1;
  if (!hasPartPayments || !isPartPaymentExperimentActive) {
    return null;
  }

  const lowestInterest = Math.min(...partPayments.map(p => p.interest));
  const sortedPartPayments = partPayments.toSorted((a, b) => a.costPerMonth - b.costPerMonth);

  const minCostPayment = sortedPartPayments[0];
  const monthlyPriceText = `${minCostPayment.costPerMonth} ${rm('shared_partpayment')}`;
  const [partPaymentFrom, withSVEA] = rm(
    'product_price_partpayment_svea',
    minCostPayment.costPerMonth
  ).split(monthlyPriceText);

  return (
    <>
      <div className={styles.box}>
        <span>
          {partPaymentFrom}
          <strong>{monthlyPriceText}</strong>
          {withSVEA}
        </span>
        <Button appearance="link" onClick={toggleModal}>
          {rm('read_more')}
        </Button>
      </div>
      <Modal show={showModal} onClose={toggleModal} contentClassName={styles.modal}>
        <div className={styles.content}>
          <div className={styles.header}>
            <IconSvea key="svea" size="xl2" className={styles.icon} />
            <h3>{rm('product_partpayment_modal_title', lowestInterest)}</h3>
            <p>{rm('product_partpayment_modal_subtitle', presentationPrice)}</p>
          </div>

          <div className={styles.body}>
            {sortedPartPayments.map(payment => (
              <div key={payment.id} className={styles.paymentWrapper}>
                <span className={styles.smallText}>
                  {rm('checkout_partpayment_months', payment.months)}
                </span>
                <span className={styles.partPaymentText}>{payment.specialPartPaymentString}</span>
                <div className={cn(styles.costInfoBlock, styles.smallText)}>
                  <span>
                    {rm(
                      'checkout_partpayment_interest_rd3',
                      payment.interest,
                      payment.startFeeText,
                      payment.monthFeeText
                    )}
                  </span>
                  <span className={styles.costPerMonth}>
                    {!payment.isCampaign &&
                      rm('checkout_partpayment_monthprice', payment.costPerMonthText, '')}
                  </span>
                </div>
              </div>
            ))}
            <CreditWarning />
          </div>
          <div className={styles.footer}>
            <Button
              appearance="whitePillPrimary"
              onClick={toggleModal}
              className={styles.closeButton}
            >
              {rm('shared_button_close')}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
